export default __webpack_public_path__ + "static/media/gallery_02.5792d568.jpg";